module.exports = __webpack_public_path__ + "img/per12.91be9c82.png";